require("dotenv").config();
import axios from "axios";

const apiURL = `${process.env.VUE_APP_TRANSLATIONS_APP_API_URL}/admin/analytics`;

class AnalyticsService {
  // Get anlaytics
  static GetAnalytics(data) {
    return new Promise((resolve, reject) => {
      resolve(
        (async () => {
          try {
            return await axios.post(`${apiURL}/get`, data).then(
              (response) => {
                return response.data;
              },
              (error) => {
                return error.response.data;
              }
            );
          } catch (e) {
            console.error("err", e);
            reject(e);
          }
        })()
      );
    });
  }
}

export default AnalyticsService;
